/** Number of minutes needed to launch a refetch of the non-synchronized data */
export const NUMBER_OF_MINUTES_FOR_REFETCH = 5;
export const NUMBER_OF_MINUTES_FOR_RESYNC = 60;
export const SECONDS_BEFORE_RETRYING_A_FAILED_FETCH = 30;
const MILLISECONDS_IN_A_SECOND = 1000;
export const MILLISECONDS_BEFORE_RETRYING_A_FAILED_FETCH =
  (SECONDS_BEFORE_RETRYING_A_FAILED_FETCH + 1) * MILLISECONDS_IN_A_SECOND;
export const FORBIDDEN_OBJECT_KEYS = ['_version', '_lastChangedAt'];
export const VERSION_CONFLICT_ATTEMPTS = 3;
export const MILLISECONDS_BEFORE_RETRYING_A_VERSION_CONFLICT = 250;
